import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ReactComponent as ImgPhone } from "../assets/images/img_phone.svg";
import { ReactComponent as ImgOffice } from "../assets/images/img_office_building.svg";
import { ReactComponent as ImgEmail } from "../assets/images/img_email.svg";
import Strings from "../utils/stringUtil";
import theme from "../utils/themeUtil";
import TextSize from "../utils/textSizeUtil";
import { isMobile } from "../utils/responsiveUtil";
import styles from "../assets/styles/main.module.css";
import Seo from "../components/seo";
import withLoader from "../components/ui/withLoader";

const sections = [
  {
    text: Strings.callUs,
    description: Strings.callTo8095171600,
    icon: ImgPhone,
  },
  { text: Strings.office, description: Strings.officeAddress, icon: ImgOffice },
  {
    text: Strings.emailUs,
    description: Strings.customerCareId,
    icon: ImgEmail,
  },
];

const Contact = () => (
  <React.Fragment>
    <Seo
      title={Strings.contactMetaTitle}
      description={Strings.contactMetaDescription}
      keywords={Strings.contactMetaKeyword}
    />
    <Box bgcolor={theme.palette.lightWhite.main} py={isMobile ? 2 : 10}>
      <Box className={styles.container}>
        <Typography
          style={{
            fontSize: TextSize.size32,
            fontWeight: "bold",
            color: theme.palette.black.main,
            textAlign: "center",
          }}
        >
          {Strings.contactUs}
        </Typography>
        <Grid container spacing={2}>
          {sections.map((section, index) => (
            <Grid
              key={index}
              item
              xs={12}
              md={4}
              style={{ textAlign: "center" }}
            >
              <Box textAlign="center" p={isMobile ? 2 : 5} mb={2}>
                <section.icon
                  width={"80px"}
                  height={"80px"}
                  alt={`${section.text} Icon`}
                />
                <Box mt={2.5}>
                  <Typography
                    style={{
                      fontSize: TextSize.size18,
                      color: theme.palette.black.main,
                      fontWeight: "600",
                    }}
                  >
                    {section.text}
                  </Typography>
                </Box>
                <Box mt={1}>
                  <Typography
                    style={{
                      fontSize: TextSize.size16,
                      color: theme.palette.black.main,
                    }}
                  >
                    {section.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  </React.Fragment>
);

export default withLoader(Contact);
